// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DataItemListPagingResultModel from '../../model/data-item-list-paging-result-model';
import DataItemListPagingResultDTO from '../dto/data-item-list-paging-result-dto';
import dtoSchema from '../schemas/data-item-list-paging-result-schema';
import DataItemListModel from '../../model/data-item-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class DataItemListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DataItemListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => DataItemListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: DataItemListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<DataItemListPagingResultDTO>): DataItemListPagingResultModel;
  static toModel(dto: DeepPartial<DataItemListPagingResultDTO> | undefined | null): DataItemListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<DataItemListPagingResultDTO> | undefined | null): DataItemListPagingResultModel | undefined {
    return dto ? new DataItemListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DataItemListPagingResultModel> | DataItemListPagingResultModel): DataItemListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as DataItemListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DataItemListPagingResultModel, can not map to DataItemListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
